import React from 'react'
import { FeaturedLayout } from '../../layouts'
import ConceptosTab from './ConceptosTab'

const PagosConceptos = () => {
  return (
    <FeaturedLayout
      title="Conceptos de cobro"
      subtitle="Catalogo de conceptos de pago del club"
    >
      <ConceptosTab />
    </FeaturedLayout>
  )
}

export default PagosConceptos
